import db from '../../firebaseConfig';

const state = {
    livelist: [],
    indexes: [],
    currentIsin: null,
    lastReload: 0
};

export default {
    namespaced: true,
    state,
    getters: {
        livelist: state => state.livelist,
        indexes: state => state.indexes,
        lastReload: state => state.lastReload,
        filterLivelist: state => search => {
            return state.livelist.filter(ins => {
                return ins.na.toLowerCase().indexOf(search.toLowerCase()) > -1
                || ins.isin.toLowerCase().indexOf(search.toLowerCase()) > -1
                || ins.sy.toLowerCase().indexOf(search.toLowerCase()) > -1
            })
        },
        filterIsin: state => isins => {
            return state.livelist.filter(ins => {
                return !!isins.find(
                    isin => ins.isin === isin
                  )
            })
        },
        current: state => state.livelist.find(ins => ins.isin == state.currentIsin),
        addInfoToList: state => pos => {
            return pos.map( p => {
                return {...p, info: state.livelist.find(ins => ins.isin==p.isin) }
            })
        },
        totalPortfolio: state => conf => {
            return conf.positions
            .map( p => {
                return {...p, info: state.livelist.find(ins => ins.isin==p.isin) }
            })
            .filter(p => !!p.info)
            .reduce((p,c) => p + (c.info.li.last*c.quantity), 0) 
            + conf.cash;
        },
    },
    mutations: {
        UPDATE_LIVE_INSTRUMENTS: (state, payload) => state.livelist = payload,
        UPDATE_LAST_RELOAD: (state, payload) => state.lastReload = payload,
        UPDATE_LIVE_INDEXES: (state, payload) => state.indexes = payload,
        SET_CURRENT_INSTRUMENT: (state, payload) => state.currentIsin = payload,
    },
    actions: {
        select({ commit, dispatch }, payload) {
            commit('SET_CURRENT_INSTRUMENT', payload.isin);
            dispatch('auth/addSearch', payload.isin, { root: true });
        },
        getLive({ commit, rootState }, payload) {
            const target = payload === 'pea' ? 'current' : payload;
            db.collection('instruments')
            .doc(target)
            .get()
            .then(snapshot => {
                const document = snapshot.data();
                const t = +(new Date())/1000;
                const conf = rootState.auth.conf;
                const list = document.d.filter(i => {
                    // Pas d'affichage des index -> todo, mettre dans une autre liste
                    if( i.ty === 'index' ) return false;
                    if( i.ty === 'Crypto') return true;
                    if( i.mk === 'US') return true;
                    
                    // déjà en portefeuille, pas de filtrage
                    if( conf.positions && conf.positions.find(p => p.isin === i.isin)) return true;

                    // filtre Tracker
                    if( !conf.displayETF && i.ty === 'tracker' ) return false;
                    // filtre fonds
                    if( !conf.displayFund && i.ty === 'investmentFund' ) return false;
                    // filtre action 
                    if( !conf.displayNoQuotes && (t-i.li.lt) > 7*24*3600) return false;
                    // filtre volume min
                    if( conf.minimumVolume && i.li && i.in && i.in.av*i.li.last < conf.minimumVolume ) return false;
                    // filtre volume max
                    if( conf.maximumVolume && i.li && i.in && i.in.av*i.li.last > conf.maximumVolume ) return false;
                    // filtre value min
                    if( conf.minimumValue && i.li && i.li.last < conf.minimumValue ) return false;
                    // filtre value max
                    if( conf.maximumValue && i.li && i.li.last > conf.maximumValue ) return false;
                    // filtre sur les valeurs bearish
                    if( conf.hideBearish && i.in && !i.in.p) {
                        const last = i.li.last || i.li.c;
                        if( (last-i.in.bk)/i.in.bk*100 < -5 ) return false;
                    }
                    // filtre si le marché de la valeur est filtré
                    if( conf.places && !conf.places[i.mk.toLowerCase()]) {
                        if( conf.displayFund && i.mk === '-') {
                            // Fund has special market name
                        } else {
                            return false;
                        }
                    }

                    return true;
                })

                if (conf.vals) {
                    conf.vals.forEach(v => {
                        console.log('add')
                        list.push({
                            ty: 'na',
                            id: v.isin,
                            na: v.na,
                            sy: v.sy,
                            isin: v.isin,
                            mk: 'CUSTOM',
                            pd: 4,
                            li: {
                                t: +new Date()/1000,
                                o: v.v,
                                c: v.v,
                                l: v.v,
                                h: v.v,
                                v: 0,
                                last: v.v,
                                lt: +new Date()/1000,
                            },
                            in: {
                                av: true
                            }
                        })
                    })
                }
                commit('UPDATE_LIVE_INSTRUMENTS', list.sort((a,b) => a.na.localeCompare(b.na)));
                commit('UPDATE_LAST_RELOAD', t);

                const indexes = document.d.filter(i => i.ty === 'index');
                commit('UPDATE_LIVE_INDEXES', indexes.sort((a,b) => a.na.localeCompare(b.na)))
            })
        },
    }
};